import React, { lazy, Suspense } from "react";
import { Card, Spin } from "antd";
import DashboardTable from "@/pages/dashboard/dashboard.table";
import { CartTable } from "@/pages/cart-management/cart.lazy";

// Thumbnail view (and antd Image) loads only when a user switches to it (AB#2926).
const DashboardThumbnailView = lazy(() => import("@/pages/dashboard/thumbnail-view/dashboard.thumbnail-view"));

const ThumbnailFallback = () => (
  <div className="display-center" style={{ justifyContent: "center", padding: 24 }}>
    <Spin />
  </div>
);

const TableComponent = ({
  isDocumentsTab,
  isFavouriteTab,
  isCartTab,
  getDashboardTableHeight,
  tableRef,
  isThumbnailView,
  resetSearchValues,
  tableData,
  tableCount,
  refetch,
  isLoading,
  allItemsCount,
  updateTotalDocumentCount,
  width,
  queryFilters,
}) => {
  if (isThumbnailView && (isCartTab || isDocumentsTab || isFavouriteTab)) {
    return (
      <div ref={tableRef} className="content-dashboard-panel">
        <Card className="dashboard-card-body thumbnail-card-body">
          <Suspense fallback={<ThumbnailFallback />}>
            <DashboardThumbnailView
              tableData={tableData}
              tableCount={tableCount}
              refetch={refetch}
              isLoading={isLoading}
              id={isCartTab ? "cartManagementTable" : "dashboardTable"}
              updateTotalDocumentCount={updateTotalDocumentCount}
              isFavouriteTab={isFavouriteTab}
              queryFilters={queryFilters}
            />
          </Suspense>
        </Card>
      </div>
    );
  } else if (isDocumentsTab || isFavouriteTab) {
    return (
      <div ref={tableRef} className="content-dashboard-panel dashboard-native-scroll-panel">
        <Card className="dashboard-card-body">
          <DashboardTable
            tableData={tableData}
            tableCount={tableCount}
            allItemsCount={allItemsCount}
            refetch={refetch}
            isLoading={isLoading}
            id="dashboardTable"
            resetSearch={resetSearchValues}
            isResizable
            isReorderable
            showTotalCount
            showSiteColumn={false}
            getTableHeight={getDashboardTableHeight}
            updateTotalDocumentCount={updateTotalDocumentCount}
            isFavouriteTab={isFavouriteTab}
            width={width}
            queryFilters={queryFilters}
          />
        </Card>
      </div>
    );
  } else if (isCartTab) {
    return (
      <div ref={tableRef} className="content-dashboard-panel dashboard-native-scroll-panel">
        <Card className="dashboard-card-body">
          <CartTable
            tableData={tableData}
            tableCount={tableCount}
            refetch={refetch}
            isLoading={isLoading}
            id="cartDashboard"
            documentStatusId={1}
            cardDocumentsName={"dashboardCartDocumentIds"}
            getTableHeight={getDashboardTableHeight}
            updateTotalDocumentCount={updateTotalDocumentCount}
            width={width}
          />
        </Card>
      </div>
    );
  }

  return null;
};

export default TableComponent;
